module.exports = __webpack_public_path__ + "img/deviceManage.cb6efca5.svg";